import type { PokemonV2 } from '../pokemon/pokemon';
import type { PokemonType } from '../types/type';
import { getSilvallyMemoryType } from '../pokemon/PlateUtils';

const SILVALLY_SPECIES_ID = 773;

// マルチアタック（Multi-Attack）のタイプを決定する
// - シルヴァディがメモリ系の持ち物を所持している場合、そのメモリに応じてタイプが変化する
// - メモリを所持していない場合は技の元タイプ（通常: ノーマル）のまま
export const resolveMultiAttackMoveType = (
  pokemon: Pick<PokemonV2, 'id' | 'species_id' | 'selected_item_id'>,
): PokemonType | undefined => {
  const speciesId = pokemon.species_id ?? pokemon.id;
  const isSilvally = speciesId === SILVALLY_SPECIES_ID || pokemon.id === SILVALLY_SPECIES_ID;
  if (!isSilvally) return undefined;

  const memoryType = getSilvallyMemoryType(pokemon.selected_item_id);
  return memoryType ?? undefined;
};

